module.exports = __webpack_public_path__ + "img/img_ibama_consulta.76465879.jpg";